import React, { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { LoadingSpinner } from '../../@paco/components'
import { getHourBalance } from '../../@paco/redux/hourBalances/hourBalancesActions'
import { useTypedDispatch, useTypedSelector } from '../../@paco/redux/store'

import EmployeeBalancesPerPeriod from '../../containers/EmployeeBalancesPerPeriod/EmployeeBalancesPerPeriod'
import { PayrollPeriod } from '../../models'
import { getCurrentPayrollPeriod } from '../../redux/absences-ts/absencesActions'
import { getPayrollPeriods } from '../../redux/app-ts/appActions'
import { Reducers } from '../../redux/reducers'
import { switchToNextOrPreviousPayrollPeriod } from '../../services/PayrollPeriodServices/PayrollPeriodService'

const ConnectedEmployeeBalancesPerPeriod: FC = () => {
    const dispatch = useDispatch()
    const typedDispatch = useTypedDispatch()

    const payrollPeriods = useSelector((state: Reducers) => state.appReducer.payrollPeriods)
    const currentPayrollPeriod = useSelector((state: Reducers) => state.absencesReducer.currentPayrollPeriod)

    const {
        isLoading,
        hourBalances,
    } = useTypedSelector((state) => state.hourBalancesReducer)

    const [activePayrollPeriod, setActivePayrollPeriod] = useState<PayrollPeriod | null>(null)

    useEffect(() => {
        if (! activePayrollPeriod) {
            dispatch(getCurrentPayrollPeriod())
            setActivePayrollPeriod(currentPayrollPeriod)
        }
    }, [currentPayrollPeriod, payrollPeriods])

    useEffect(() => {
        if (! payrollPeriods.length) {
            dispatch(getPayrollPeriods())
        }
    }, [])

    useEffect(() => {
        if (activePayrollPeriod) typedDispatch(getHourBalance(activePayrollPeriod)).then()
    }, [activePayrollPeriod])

    const switchPayrollPeriod = (nextPeriod: boolean) => {
        const payrollPeriod = activePayrollPeriod
            && switchToNextOrPreviousPayrollPeriod(activePayrollPeriod, payrollPeriods, nextPeriod)
        setActivePayrollPeriod(payrollPeriod)
    }

    if (! payrollPeriods.length || ! activePayrollPeriod) {
        return <LoadingSpinner />
    }

    return (
        <EmployeeBalancesPerPeriod
            loading={isLoading}
            activePayrollPeriod={activePayrollPeriod}
            hourBalances={hourBalances && hourBalances.length > 0 ? hourBalances[0] : undefined}
            switchPayrollPeriod={switchPayrollPeriod}
        />
    )
}

export default ConnectedEmployeeBalancesPerPeriod
